<script setup>
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
import { unexpectedError } from '@/shared/utils/unexpected-error.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

const authStore = useAuthStore();
const toast = useToast();
const { t } = useI18n();

const showVerifyButton = ref(true);

const resendVerifyEmail = async () => {
    if (authStore.isVerified) {
        toast.error(t('auth.email_already_verified'));

        return;
    }

    showVerifyButton.value = false;

    try {
        await authStore.resendVerifyEmail();

        toast.success(t('auth.verification_email_sent'));
    } catch (error) {
        showVerifyButton.value = true;

        unexpectedError(error);
    }
};
</script>

<template>
    <div
        v-if="!authStore.isVerified || authStore.hasPendingChange"
        class="border-warning text-warning mb-8 flex flex-wrap items-center justify-between gap-4 border bg-transparent px-6 py-4 lg:mr-52 xl:flex-nowrap"
    >
        <div class="grow font-bold">
            {{ $t('auth.email_not_verified') }}
        </div>

        <button
            v-if="showVerifyButton"
            type="button"
            class="bg-warning hover:bg-warning/80 shrink-0 cursor-pointer px-3 py-2 text-sm font-bold text-white"
            @click="resendVerifyEmail"
        >
            {{ $t('auth.resend_verification_email') }}
        </button>
    </div>
</template>
